




import { Component, Vue } from 'vue-property-decorator'
import detailCom from './detailCom.vue'
@Component({
  name: 'detail',
  components: {
    detailCom
  }
})
export default class extends Vue {
  sourceData = {
    upDownUrl: '/blackcat/story/line/tenant/online',
    onLineType: 'tenantOnline'
  }
}
